// removed by extract-text-webpack-plugin
module.exports = {"table":"_3PEa"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Tables/SimpleTable/SimpleTable.scss
// module id = pC7e
// module chunks = 0